import { Tooltip } from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import GetApp from "@mui/icons-material/GetApp";
import * as FileSaver from "file-saver";
import writeExcelFile from "write-excel-file/browser";

const TrackHcaExportFile = ({ csvData, fileName }) => {
  const fileExtension = ".xlsx";

  const getExportStatusLabel = (status) => {
    const normalized = String(status || "")
      .trim()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ")
      .toUpperCase()
      .replace("NOTFOUND", "NOT FOUND");

    return normalized
      .toLowerCase()
      .split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getExportEphStatusLabel = (ephStatus) => {
    if (ephStatus === true || ephStatus === "true") {
      return "Success";
    }

    if (ephStatus === false || ephStatus === "false") {
      return "Failed";
    }

    return ephStatus ?? "";
  };

  const getExportOktaPassportValue = (record) => record?.okta_id || record?.passport_id || "";

  const exportToCSV = async (records, exportFileName) => {
    // Define table columns in the same order as displayed in the UI
    const tableColumns = [
      { header: "Request ID", key: "request_id" },
      { header: "HCP Enterprise ID", key: "hcp_enterprise_id" },
      { header: "Status", key: "status" },
      { header: "EPH Status", key: "eph_status" },
      { header: "Okta ID/Passport ID", key: "okta_id" },
      { header: "One Key ID", key: "one_key_id" },
      { header: "Created Date", key: "created_date" },
      { header: "Updated Date", key: "updated_date" },
    ];

    let columns;
    let dataRows;

    if (!Array.isArray(records) || records.length === 0) {
      columns = [{ header: "Info", key: "Info" }];
      dataRows = [[{ value: "No records found" }]];
    } else {
      columns = tableColumns;
      dataRows = records.map((record) => {
        return tableColumns.map((col) => {
          let value;
          if (col.key === "status") {
            value = getExportStatusLabel(record?.[col.key]);
          } else if (col.key === "eph_status") {
            value = getExportEphStatusLabel(record?.[col.key]);
          } else if (col.key === "okta_id") {
            value = getExportOktaPassportValue(record);
          } else {
            value = record?.[col.key] ?? "";
          }
          return { value };
        });
      });
    }

    const headerRow = columns.map((column) => ({
      value: column.header,
      fontWeight: "bold",
    }));

    const colWidths = columns.map((column, colIndex) => {
      const maxLen = Math.max(
        column.header.length,
        ...dataRows.map((row) => String(row[colIndex]?.value ?? "").length),
      );
      return { width: Math.max(18, maxLen + 2) };
    });

    const blob = await writeExcelFile(
      [headerRow, ...dataRows],
      {
        sheet: "HCA Requests",
        columns: colWidths,
        stickyRowsCount: 1,
      },
    ).toBlob();

    FileSaver.saveAs(blob, exportFileName + fileExtension);
  };

  return (
    <ToggleButton
      value="list"
      size="small"
      className="border-0 float-end"
      aria-label="list"
      onClick={() => exportToCSV(csvData, fileName)}
    >
      <Tooltip disableFocusListener title="Export" id="tooltip">
        <GetApp />
      </Tooltip>
    </ToggleButton>
  );
};

export default TrackHcaExportFile;
